import _toConsumableArray from "/runner/_work/miro-site/miro-site/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import { useEffect, useState } from 'react';
import { appendScript } from '../utils';

// Initialize custom event for wistia
if (true) {
  window._wq = window._wq || [];

  window._wq.push({
    id: '_all',
    onReady: function onReady() {
      document.dispatchEvent(new Event('wistia_loaded'));
    }
  });
}

var classnames = {
  thumbnail: 'wistia_thumbnail',
  responsiveWrapper: 'wistia_responsive_wrapper',
  deferred: 'wistia_deferred',
  embed: 'wistia_embed',
  swatch: 'wistia_swatch',
  background: 'background',
  async: function async(id) {
    return "wistia_async_".concat(id);
  }
};
var wistiaFlags = {
  noSEO: 'seo=false',
  videoFoam: 'videoFoam=true',
  autoPlay: 'autoPlay=true'
}; // Hook to initialize the listeners/setup on wistia (managing classes to display the video), use useEffect to avoid SSR issues

var useWistia = function useWistia(videoId) {
  var addThumbnailsListeners = function addThumbnailsListeners() {
    var thumbnails = [].slice.call(document.getElementsByClassName(classnames.thumbnail));

    var _iterator = _createForOfIteratorHelper(thumbnails),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var thumbnail = _step.value;

        if (!thumbnail.dataset.hasListeners) {
          thumbnail.dataset.hasListeners = 'true';
          thumbnail.addEventListener('click', handleThumbnailClick);
          thumbnail.addEventListener('keypress', handleThumbnailKeyPress);
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  };

  var handleThumbnailKeyPress = function handleThumbnailKeyPress(event) {
    event.preventDefault();

    if (event.key === ' ' || event.key === 'Enter') {
      handleThumbnailClick(event);
    }
  };

  var handleThumbnailClick = function handleThumbnailClick(event) {
    var _thumbnail$parentNode;

    var thumbnail = event.target;
    var wrapper = (_thumbnail$parentNode = thumbnail.parentNode) === null || _thumbnail$parentNode === void 0 ? void 0 : _thumbnail$parentNode.parentNode;

    if (!wrapper) {
      return;
    }

    var deferred = wrapper.querySelector(".".concat(classnames.deferred));

    if (deferred) {
      deferred.classList.add(classnames.responsiveWrapper);
      wrapper.style.minHeight = "".concat(thumbnail.offsetHeight, "px");
      thumbnail.classList.add(classnames.background);
      initWistiaVideo({
        wrapper: deferred
      });
    }
  };

  var initializeWrappers = function initializeWrappers() {
    var wrappers = [].slice.call(document.getElementsByClassName(classnames.responsiveWrapper));

    if (wrappers.length === 0) {
      return;
    }

    var _iterator2 = _createForOfIteratorHelper(wrappers),
        _step2;

    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var wrapper = _step2.value;
        initWistiaVideo({
          wrapper: wrapper
        });
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
  };

  useEffect(function () {
    if (videoId) {
      addThumbnailsListeners();
      initializeWrappers();
    }
  });
};

var initWistiaVideo = function initWistiaVideo(_ref) {
  var wrapper = _ref.wrapper,
      _ref$embedId = _ref.embedId,
      embedId = _ref$embedId === void 0 ? null : _ref$embedId,
      _ref$autoPlay = _ref.autoPlay,
      autoPlay = _ref$autoPlay === void 0 ? false : _ref$autoPlay,
      _ref$videoId = _ref.videoId,
      videoId = _ref$videoId === void 0 ? null : _ref$videoId,
      _ref$classes = _ref.classes,
      classes = _ref$classes === void 0 ? [] : _ref$classes;

  if (!wrapper || wrapper.dataset.wistiaPrepared) {
    return;
  }

  var wistiaId = wrapper.dataset.wistiaVideoId || videoId;

  if (wistiaId) {
    var _embed$classList;

    appendWistiaScript();
    wrapper.dataset.wistiaPrepared = 'true';
    var wrapperIsDeferred = wrapper.classList.contains(classnames.deferred);
    var embedClasses = [classnames.embed, classnames.async(wistiaId), wistiaFlags.noSEO, wistiaFlags.videoFoam];

    if (classes.length) {
      embedClasses.push.apply(embedClasses, _toConsumableArray(classes));
    }

    if (autoPlay || wrapperIsDeferred) {
      embedClasses.push(wistiaFlags.autoPlay);
    }

    var embed = document.createElement('div');

    (_embed$classList = embed.classList).add.apply(_embed$classList, embedClasses);

    var swatch = document.createElement('div');
    swatch.classList.add(classnames.swatch);
    swatch.style.cssText = 'height:100%;left:0;opacity:0;overflow:hidden;position:absolute;top:0;transition:opacity 200ms;width:100%;';
    wrapper.appendChild(embed).appendChild(swatch);
    wrapper.dataset.testid = 'wistia-element-ref';

    if (embedId) {
      embed.id = embedId;
    }
  }
}; // Wistia hook so we can have easy access to "onReady" listener and get the video api


var useWistiaVideoApi = function useWistiaVideoApi(_ref2) {
  var id = _ref2.id,
      jsonp = _ref2.jsonp,
      _onReady = _ref2.onReady,
      _ref2$options = _ref2.options,
      options = _ref2$options === void 0 ? {} : _ref2$options;

  var _useState = useState(),
      videoApi = _useState[0],
      setVideoApi = _useState[1];

  useEffect(function () {
    window._wq = window._wq || [];

    window._wq.push({
      id: id,
      onReady: function onReady(api) {
        setVideoApi(api);

        if (jsonp) {
          appendWistiaJsonpScript(id);
        }

        _onReady && _onReady(api);
        return api;
      },
      options: options
    });
  }, []);
  return videoApi;
};

var appendWistiaScript = function appendWistiaScript() {
  appendScript('https://fast.wistia.com/assets/external/E-v1.js');
};

var appendWistiaJsonpScript = function appendWistiaJsonpScript(id) {
  appendScript("https://fast.wistia.com/embed/medias/".concat(id, ".jsonp"));
};

export { initWistiaVideo, useWistia, useWistiaVideoApi, appendWistiaScript, appendWistiaJsonpScript };